export default [
  {
    path: '/preorder-configuration',
    name: 'list-preorderConfiguration',
    component: () => import('@/views/preorderConfiguration/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.preOrder',
      resource: 'event',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.preOrder',
          active: true,
        },
      ],
    },
  },
]
